import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import React from "react";
import {inventarioResources} from "../endpoints";

class DialogInvRef extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            title: props.title,
            inv_ref: "",
            rowData: props.rowData,
        }
    }

    handleChange = e =>{
        this.setState({[e.target.name]: e.target.value});
    }

    modificaInvRef = ()=>{
        let folio = this.state.rowData.folio
        inventarioResources.modificarInvRef(folio, this.state.inv_ref).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.props.refrescar(result)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            let result ={
                message:"Ha ocurrido un error inesperado",
                severity: "error",
                status_code: 400
            }
            this.props.refrescar(result)
            console.log(error)
        });

    }

    omitir = ()=>{
        let result ={
            message:"Omitiendo",
            severity: "success",
            status_code: 200
        }

        this.props.refrescar(result)

    }

    render() {
        return(
            <Dialog
                open={true}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{this.state.title}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} alignItems="flex-end">
                        <Grid item xs={12}>
                            Inv. referencia: <TextField value={this.state.inv_ref} autoFocus={true} name="inv_ref" fullWidth onChange={this.handleChange}/>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="secondary" onClick={this.props.handleClose}>
                        Cancelar
                    </Button>
                    {
                        this.state.inv_ref === "" && this.state.title === "Ingresar inv. referencia" ?
                            <Button variant="contained" onClick={this.omitir} color="primary">
                                Omitir
                            </Button>:
                        <Button disabled={!this.state.inv_ref} variant="contained" onClick={this.modificaInvRef} color="primary">
                            Guardar
                        </Button>
                    }

                </DialogActions>
            </Dialog>
        )
    }
}

export default DialogInvRef;